import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { RemoveDeviceType } from "../../../services/device";

const DeleteModel = () => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.model);
    
    const cancelHandler = () => dispatch(resetModel());

    const submitHandler = () => {
        RemoveDeviceType(data.dtId).then(response => {
            if (!Object.keys(response).length) {
                cancelHandler();
                dispatch(setAction());
            }
        });
    };

    return (
        <Modal show={ true } centered>
            <Modal.Header>Remove Device</Modal.Header>
            <Modal.Body>
                <div className="subject-container">
                    <span className='subject'>Are you sure to remove this device type？</span>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                    <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default DeleteModel;